'use strict'

import css from './container-selection.styles.scss'
import template from './container-selection.template.pug'

class ContainerSelectionController {
  $onChanges() {
    this.container = null
    this.showNewContainers = !this.containersByContracts.length
  }

  select() {
    this.onSelect({ container: this.container })
  }

  reset() {
    this.container = null
    this.select()
  }
}

export const umsContainerSelection = {
  controller: ContainerSelectionController,
  template: template({ css }),
  bindings: {
    containersByContracts: '<',
    containersByTemplates: '<',
    onSelect: '&',
  },
}



// WEBPACK FOOTER //
// ./app/orders/components/container-selection/container-selection.component.js